import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { MediumSpacer } from '~/modules/coreUI/components/legacies/Spacers';
import { CenterAlignedRow } from '~/modules/coreUI/components/legacies/Rows';

const Icon = styled.i`
  &&& {
    color: ${props => props.theme.colors.labels.normal};
    font-size: ${props => props.theme.fonts.sizes.xxxSmall - 1.5}px;
    cursor: pointer;
  }
`;
const Spacer = styled(MediumSpacer)`
  display: inline-block;
`;
const Track = styled.div`
  display: inline-block;
  text-transform: capitalize;
  padding: ${props => props.theme.paddings.small}px ${props => props.theme.paddings.medium}px;
  margin-bottom: ${props => props.theme.paddings.large}px;
  font-size: ${props => props.theme.fonts.sizes.medium}px;
  line-height: ${props => props.theme.paddings.xLarge}px;
  color: ${props => props.theme.colors.labels.emphasized};
  border: ${props => props.theme.borders.size.thin}px solid
    ${props => props.theme.borders.color.normal};
  border-radius: ${props => props.theme.borders.radius.xLarge}px;
`;

const TrackFilterElement = ({ trackName, onClick }) => (
  <React.Fragment>
    <Track>
      <CenterAlignedRow>
        {trackName}
        <Spacer />
        <Icon className="icon-delete" onClick={onClick} />
      </CenterAlignedRow>
    </Track>
  </React.Fragment>
);

TrackFilterElement.propTypes = {
  trackName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default TrackFilterElement;
